module.exports = __webpack_public_path__ + "img/Guillaume Ballet.a007048a.jpg";